import RecordsWithDefectsList from "./RecordsWithDefectsList";

function WithDefectsPage() {
   return (
      <div className=''>
         <section>
            <RecordsWithDefectsList />
         </section>
      </div>
   );
}

export default WithDefectsPage;
